let fidelityDiv = document.querySelector('.fidelity');
let userId = fidelityDiv.getAttribute('data-customer');

let customer = `BioiklVGFTYguioklLKOIh7097867YUHKJNmgid://shopify/Customer/${userId}`;

let host = 'https://fidelity-herbolariosaludnatural.lineagrafica.es';
// let _host = 'http://localhost:8002';
let totalAmount = 0;

const getFidelityHistory = async() =>{
  console.log("get fidelity")
    let response = await fetch(`${host}/public/api/history`,{
        method: 'POST',
        body: JSON.stringify({'customer': btoa(customer)})
    })
    let responseJson = await response.json();
    console.log(responseJson.data);
    drawFidelityHistory(responseJson.data.last50Rows, responseJson.data.totalCashbackAvailable);
}

const drawFidelityHistory = (data, cashback) => {
    let buttonGenerateCoupon = document.querySelector('.fidelity-pocket__discounts--submit');
    let historyDiv = document.querySelector('.fidelity-history_body');
    let cashbackSpan = document.querySelector('.fidelity-pocket__total--amount');
    cashbackSpan.innerHTML =  cashback >= 0 ? Math.round((cashback - 0.01) * 100) / 100  + '€' : '0€';
    console.log(historyDiv);
    historyDiv.innerHTML = '';
    let dataReverse = data.reverse();  
    for (const item of dataReverse) {
        console.log(item);
        const date = new Date(item.dateUpd);
        if(item.orderName == null){
            item.orderName = 'Conversión cashback';
        }
        historyDiv.innerHTML += `
        <div class="fidelity-history_item">
        <div>${item.orderName}</div>
        <div>${Math.floor((item.amount + Number.EPSILON) * 100) / 100}€</div>
        <div>${item.reason}</div>
        <div>${ ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + date.getFullYear()}</div>
        </div>
        `
    }

    if(data.length == 0) {
        historyDiv.innerHTML = `
        <p style="text-align:center; padding-top:25px;">No hay movimientos que mostrar</p>`
    }
    
    buttonGenerateCoupon.disabled = false;
    buttonGenerateCoupon.addEventListener('click', () => checkAmount(cashback));
}

const checkAmount = (cashback) => {
    let buttonGenerateCoupon = document.querySelector('.fidelity-pocket__discounts--submit');
    buttonGenerateCoupon.disabled = true;
    let inputElement = document.querySelector('.fidelity-pocket__discounts--form input');
    
    if(parseFloat(inputElement.value) <= cashback && parseFloat(inputElement.value) > 0){
        generateCupon(parseFloat(inputElement.value));
        inputElement.value = '';
    }else if(parseFloat(inputElement.value) > cashback){
        let errorAmount = document.querySelector('.fidelity-pocket__discounts--error');
        errorAmount.style.display = 'block';
        inputElement.value = '';
        
        setTimeout(() => {
            errorAmount.style.display = 'none';
            buttonGenerateCoupon.disabled = false;
        }, 3000);
    }
}

const generateCupon = async(amount) => {
    let buttonGenerateCoupon = document.querySelector('.fidelity-pocket__discounts--submit');

    let response = await fetch(`${host}/public/api/discount/generate`,{
        method: 'POST',
        body: JSON.stringify({'customer': btoa(customer), 'amount': amount})
    })

    let responseJson = await response.json();
    console.log(responseJson);
    console.log(responseJson.data.data.body.data.discountCodeBasicCreate.codeDiscountNode.codeDiscount.codes.nodes[0].code);
    let discountContainer = document.querySelector('.fidelity-pocket__discounts--code');
    let discountElement = document.querySelector('.fidelity-pocket__discounts--generated-code');   
    let discountTextInitial = document.querySelector('.fidelity-pocket__discounts--code-initial');   
    let discountTextFinal = document.querySelector('.fidelity-pocket__discounts--code-final');   
    discountElement.textContent = responseJson.data.data.body.data.discountCodeBasicCreate.codeDiscountNode.codeDiscount.codes.nodes[0].code;
    discountElement.style.display = 'block';
    discountTextInitial.style.display = 'none';
    discountTextFinal.style.display = 'block';
    discountContainer.style.visibility = 'visible';

    discountElement.addEventListener('click', () => {
        navigator.clipboard.writeText(responseJson.data.data.body.data.discountCodeBasicCreate.codeDiscountNode.codeDiscount.codes.nodes[0].code);
    });

    // window.location.reload();
    getFidelityHistory();
    getFidelityDiscounts();
}

const getFidelityDiscounts = async() =>{
    console.log("get discounts")
      let response = await fetch(`${host}/public/api/customer/discounts`,{
          method: 'POST',
          body: JSON.stringify({'customer': btoa(customer)})
          // body: JSON.stringify({'customer': "QmlvaWtsVkdGVFlndWlva2xMS09JaDcwOTc4NjdZVUhLSk5tZ2lkOi8vc2hvcGlmeS9DdXN0b21lci83MTIxODYxNzM4NTg5"})
      })
      let responseJson = await response.json();
      console.log(responseJson.data);
      drawFidelityDiscounts(responseJson.data);
}

const drawFidelityDiscounts = (data) => {
    let discountsDiv = document.querySelector('.fidelity-discounts_body');

    discountsDiv.innerHTML = '';
    let dataReverse = data.data.reverse();

    for (const item of dataReverse) {
        
        discountsDiv.innerHTML += `
        <div class="fidelity-discounts_item">
        <div>${item.title}</div>
        <div>${item.discountCode}</div>
        <div>${item.used == true ? "Usado" : "Disponible"}</div>
        </div>
        `
    }

    if(dataReverse.length == 0) {
        discountsDiv.innerHTML = `
        <p style="text-align:center; padding-top:25px;">No hay descuentos que mostrar</p>`
    }

}

getFidelityHistory();
getFidelityDiscounts();